<template>
    <div class="m-viewport" v-if="ready">

        <div class="logo-view">
          <h2 class="logo_1"><a href="https://www.m3guo.com/v2/" target="_blank" rel="noopener noreferrer"></a></h2>
          <h2 class="logo_2"><a href="https://www.m3guo.com/activity/202309/preheat-lcoa/" target="_blank" rel="noopener noreferrer"></a></h2>
        </div>

        <div class="u-links">
            <div class="btn-index">
                <a href="https://www.m3guo.com/v2/" target="_blank" rel="noopener noreferrer"></a>
            </div>
            <div class="btn-dl">
              <a href="https://www.m3guo.com/v2/download/client/" target="_blank" rel="noopener noreferrer"></a>
            </div>
        </div>      

        <user-info class="m-user"/>

        <div class="page-body">
            <task/>
            <pay class="pay"/>
            <invite class="invite"/>
            <friend class="friend"/>
            <update class="update"/>
            <rule class="rule"/>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@mixin boxStyle ( $screenWidth ){

    @if ( $screenWidth == 1600) {
        .m-viewport{
            position: relative;
            width: 100%;
            max-width: 1920px;
            height: 6468px;
            margin: 0 auto;
            padding-top: 825px;
            /* overflow: hidden; */
            overflow-x: hidden;
            background-image: url(~@/assets/images/pc/body.jpg);
            background-position: center -42px;
            background-repeat: no-repeat;    
            background-color: #222229;
            box-sizing: border-box;
            font-size: 16px;    
        }

        .logo-view{
            display: flex;
            align-items: center;
            position: absolute;
            left: 2%;
            top: 10px;
        }

        .logo-view a{
            display: block;
            width: 100%;
            height: 100%;
        }

        .logo-view .logo_1{
            width: 147px;
            height: 123px;
            background-image: url(~@/assets/images/pc/logo_1.png);
        }

        .logo-view .logo_2{
            width: 125px;
            height: 125px;
            margin-left: 20px;
            background-image: url(~@/assets/images/pc/logo_2.png);
        }

        .u-links{
            display: flex;
            position: absolute;
            right: 2%;
            top: 30px;    
        }

        .btn-index{
            width: 60px;
            height: 62px;
            margin-right: 10px;
            background-image: url(~@/assets/images/pc/btn-index.png);
        }

        .btn-dl{
            width: 60px;
            height: 62px;
            background-image: url(~@/assets/images/pc/btn-dl.png);
        }

        .u-links a{
            display: block;
            width: 100%;
            height: 100%;
        }

        .m-user{
            font-size: 16px;
            color: #ffffff;
        }

        .page-body{
            width: 1201px;
            margin: 223px auto 0;
        }

        .pay{
            margin-top: 226px;
        }

        .invite{
            margin-top: 182px;
        }

        .friend{
            margin-top: 174px;
        }

        .update{
            margin-top: 102px;
        }

        .rule{
            margin-top: 200px;
        }
    }@else if( $screenWidth == 1000 ) {
        .m-viewport{
            position: relative;
            width: 750px;
            height: 8600px;
            margin: 0 auto 0;
            background-image: url(~@/assets/images/m/body.jpg);
            background-size: 100% auto;
            background-repeat: no-repeat;
            background-position: top center;
            box-sizing: border-box;
            overflow-x: hidden; 
            padding-top: 1112px;
        }

        .logo-view{
            display: flex;
            align-items: center;
            position: absolute;
            left: 2%;
            top: 10px;
        }

        .logo-view a{
            display: block;
            width: 100%;
            height: 100%;
        }

        .logo-view .logo_1{
            width: 147px;
            height: 123px;
            background-image: url(~@/assets/images/pc/logo_1.png);
        }

        .logo-view .logo_2{
            width: 125px;
            height: 125px;
            margin-left: 20px;
            background-image: url(~@/assets/images/pc/logo_2.png);
        }

        .m-user{
            font-size: 24px;
            color: #ffffff;
        }

        .page-body{
            margin: 223px auto 0;
            // padding: 0 20px;
        }

        .pay{
            margin-top: 226px;
        }

        .invite{
            margin-top: 182px;
        }

        .friend{
            margin-top: 174px;
        }

        .update{
            margin-top: 102px;
        }

        .rule{
            margin-top: 200px;
        } 

    }    

}

@media screen and (min-width: 1000px){
  @include boxStyle( 1600 );
}
@media screen and (min-width: 375px) and (max-width: 999px){
  @include boxStyle( 1000 );
}
</style>

<style>
.slogen{
    margin-top: 12px;
    font-size: 16px;
    color: #5f4530;
    text-align: center;
}

</style>

<script>
import task from '@/views/task'
import pay from '@/views/pay'
import invite from '@/views/invite'
import friend from '@/views/friend'
import update from '@/views/update'
import rule from '@/views/rule'

export default {
    components: {
        task,
        pay,
        invite,
        friend,
        update,
        rule,
    },
    props : {
      ready : {
          default : false,
      },                           
    },          
}
</script>


// WEBPACK FOOTER //
// src/page/index/index.vue